import { useState, useCallback } from 'react';

const useToggle = (initialValue: boolean = false): [boolean, () => void] => {
  const [isToggled, setIsToggled] = useState<boolean>(initialValue);

  // Using useCallback to memoize the toggle function
  const toggle = useCallback(() => {
    setIsToggled((state) => !state);
  }, []);

  return [isToggled, toggle];
};

export default useToggle;
